import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultFileUploads } from "../../../../Constant";
import { DEFAULT_FILE_UPLOAD } from "../../../../Data/Bonus Ui/Dropzone";
import { useState } from "react";
import { FilePond } from "react-filepond";

const DefaultFileUpload = () => {
  const [files, setFiles] = useState([]);

  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={DefaultFileUploads} span={DEFAULT_FILE_UPLOAD} />
        <CardBody className="mt-3 mb-3">
          <FilePond files={files} onupdatefiles={() => setFiles} allowMultiple={true} maxFiles={1} labelIdle={'Drag & Drop your files or <span class="filepond--label-action text-danger text-decoration-none">Browse</span>'} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultFileUpload;
